import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import ResetPasswordForm from '../components/auth/ResetPasswordForm';
import LoadingSpinner from '../components/LoadingSpinner';
import './AuthPage.css';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [token, setToken] = useState(null);
  const [isValidToken, setIsValidToken] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Extract token from URL parameters
    const tokenParam = searchParams.get('token');
    
    if (!tokenParam) {
      setError('Invalid reset link. Please request a new password reset.');
      setIsValidToken(false);
      return;
    }

    setToken(tokenParam);
    setIsValidToken(true);
  }, [searchParams]);

  const handleResetSuccess = () => {
    // Redirect to login page after successful reset
    setTimeout(() => {
      navigate('/auth');
    }, 2000);
  };

  if (isValidToken === null) {
    return (
      <Layout>
        <div className="auth-page-simple">
          <div className="auth-container-simple">
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <LoadingSpinner size="large" message="Validating reset link..." />
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  if (!isValidToken || error) {
    return (
      <Layout>
        <div className="auth-page-simple">
          <div className="auth-container-simple">
            <div className="auth-form">
              <div className="auth-header">
                <h2>Invalid reset link</h2>
                <p>This password reset link is invalid or has expired.</p>
              </div>

              <div className="error-message">
                {error || 'The reset link may have expired or been used already.'}
              </div>

              <div className="form-footer">
                <button
                  type="button"
                  className="submit-button"
                  onClick={() => navigate('/auth?view=forgot-password')}
                >
                  Request a new reset link
                </button>
                <p style={{ textAlign: 'center', marginTop: '1rem' }}>
                  <button
                    type="button"
                    className="link-button primary"
                    onClick={() => navigate('/auth')}
                  >
                    Back to sign in
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="auth-page-simple">
        <div className="auth-container-simple">
          <ResetPasswordForm 
            token={token} 
            onSuccess={handleResetSuccess} 
          />
        </div>
      </div>
    </Layout>
  );
};

export default ResetPasswordPage;